<template>
  <div>
    <router-view></router-view>

  </div>
</template>
<script>

export default {
  name: 'app',
  components: {

  },
  data () {
    return {
      togleState: true
    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue